import { DefaultVariantTitle } from '@/lib/variants';
import { useCartStore } from 'stores/useCartStore';

export const InexistentVariant = {
  id: '',
  availableForSale: false,
  selectedOptions: [],
  image: {
    id: '',
    url: '',
    altText: null,
    width: null,
    height: null
  },
  price: { amount: '0', currencyCode: 'Nill' },
  compareAtPrice: { amount: '0', currencyCode: 'USD' },
  sku: null,
  title: 'Not in Stock',
  unitPrice: null
};

export const parseVariantName = (title: string) =>
  title === DefaultVariantTitle
    ? ''
    : title
        .replaceAll(' / ', ' - ')
        .replaceAll(':', ' ')
        .replaceAll(/#\w*/g, '');

export const otherVariantsInCart = (variantId: string, productId: string) => {
  const cart = useCartStore.getState().cart;
  const otherVariantsInCart = productId
    ? cart?.lines.nodes
        .filter(
          (item) =>
            item.merchandise.product.id === productId &&
            item.merchandise.id !== variantId
        )
        .reduce((acc, prod) => {
          return acc + prod.quantity;
        }, 0) || 0
    : 0;
  return otherVariantsInCart;
};
